import React, { Component } from 'react';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import Modal from 'react-modal';
import DateTimePicker from 'react-datetime-picker';
import './style.css';

class ReceivingReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      cl_id: localStorage.getItem('headerClientId') || '',
      start_date: moment().subtract(7, 'days').toDate(),
      end_date: new Date(),
      loading: false,
      error: '',
      dataToDownload: [],
      sortOptions: [{ id: 'cl_id', desc: false }]
    };

    this.fetchReport = this.fetchReport.bind(this);
    this.handleClChange = this.handleClChange.bind(this);
    this.handleStartChange = this.handleStartChange.bind(this);
    this.handleEndChange = this.handleEndChange.bind(this);
  }

  componentDidMount() {
    try { Modal.setAppElement('#main'); } catch (e) {}
    // auto-run initial report
    this.fetchReport();
  }

  handleClChange(e){
    this.setState({ cl_id: e.target.value });
  }

  handleStartChange(date){
    this.setState({ start_date: date });
  }

  handleEndChange(date){
    if (!date) return;
    const updatedDate = new Date(date);
    updatedDate.setHours(23,59,0,0);
    this.setState({ end_date: updatedDate }, () => {
      // automatically refresh when end date is selected
      this.fetchReport();
    });
  }

  async fetchReport(){
    this.setState({ loading: true, error: '' });
    try{
      const body = {
        cl_id: this.state.cl_id,
        start_date: moment(this.state.start_date).format('YYYY-MM-DD'),
        end_date: moment(this.state.end_date).format('YYYY-MM-DD')
      };

      const res = await fetch(process.env.REACT_APP_NODE_ROOT_URL + '/reports/receiving/' + this.state.cl_id, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('Network response was not ok');
      const data = await res.json();
      this.setState({ data, loading: false });
    } catch (err){
      this.setState({ error: err.message, loading: false });
    }
  }

  prepareDownload(){
    if (!this.state.data || this.state.data.length===0) return [];
    const keys = Object.keys(this.state.data[0]);
    const rows = this.state.data.map(r => {
      const out = {};
      keys.forEach(k => out[k] = r[k]);
      return out;
    });
    // don't call setState during render; just return the prepared rows
    return rows;
  }

  render(){
    const { data } = this.state;
    return (
      <div id="main">
        <div className="page-wrapper">
          <div className="row page-titles">
            <div className="col-md-11 align-self-center">
              <h3 className="text-primary">Receiving Report</h3>
            </div>
            <div className="col-md-1 align-self-center"></div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card-body" name="card-order-list">
                  Select a Start and End Date for the report to see results.
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          Start Date:<br />
                          <DateTimePicker
                            disableClock={true}
                            onChange={this.handleStartChange}
                            value={this.state.start_date}
                            format={"MM-dd-y"}
                          />
                        </td>
                        <td>
                          End Date:<br />
                          <DateTimePicker
                            disableClock={true}
                            onChange={this.handleEndChange}
                            value={this.state.end_date}
                            format={"MM-dd-y"}
                          />
                        </td>
                        <td style={{verticalAlign: 'bottom'}}>
                          <button className="btn btn-info btn-sm" onClick={() => this.fetchReport()} disabled={this.state.loading}>
                            {this.state.loading ? 'Loading...' : 'Run Report'}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <div className="card-body" name="card-order-list">
                    <div>
                      <CSVLink filename="receiving.csv" data={this.prepareDownload()} onClick={() => {}}><strong>Download receiving report</strong></CSVLink>
                    <br/>
                    <hr/>
                    </div>
                    {/* Render metrics in a compact key/value grid for readability. Keep raw table inside a collapsible details for debugging. */}
                    {data.length === 0 ? (
                      <div>No data</div>
                    ) : (
                      <div>
                        {(() => {
                          const row = data[0];

                          // Map raw keys to friendly labels
                          const labelMap = {
                            totalReturns: 'Total Returns',
                            totalReturnsReceived: 'Returns Received',
                            totalReturnsReceivedOneDay: 'Received in 1 Day',
                            totalReturnsReceivedOneDayPercent: 'Pct Received in 1 Day',
                            orderTotal: 'Order Total',
                            totalReturnItems: 'Total Returned Items',
                            totalReturnItemsReceived: 'Returned Items Received',
                            totalContainers: 'Total Containers',
                            totalContainersReceived: 'Containers Received',
                            AverageItemsOnContainer: 'Avg Items per Container',
                            totalReturnsOnTime: 'Returns On Time',
                            totalReturnsDelayed: 'Returns Delayed'
                          };

                          // Define known explicit key -> group mappings for common metrics.
                          const explicitKeyMap = {
                            // Received group
                            totalReturnsReceived: "Returns",
                            totalReturnsReceivedOneDay: "Returns",
                            totalReturnsReceivedOneDayPercent: "Returns",
                            totalReturnsOnTime: "Returns",
                            totalReturnsDelayed: "Returns",
                            // Returned Items
                            totalReturnItems: 'Returned Items',
                            totalReturnItemsReceived: 'Returned Items',
                            totalReturns: 'Returned Items',
                            // Container-ish
                            totalContainers: 'Container',
                            totalContainersReceived: 'Container',
                            AverageItemsOnContainer: 'Container'
                          };

                          // Keyword groups for mapping keys into groups
                          const keywordGroups = [
                            { name: 'Container', keywords: ['container', 'containers'] },
                            { name: 'Pallet', keywords: ['pallet'] },
                            { name: 'Parcel', keywords: ['parcel'] },
                            { name: 'Orders', keywords: ['order', 'orders', 'ordertotal', 'order_total', 'orderTotal'] },
                            { name: 'Expedited', keywords: ['expedited', 'expedite'] },
                            { name: 'Urgent', keywords: ['urgent'] }
                          ];

                          // Small helper to format values
                          const formatValue = (k, v) => {
                            if (v === null || typeof v === 'undefined') return '';
                            // percent-ish fields (some stored as 0.93 etc.)
                            if (String(k).toLowerCase().includes('percent') || String(k).toLowerCase().includes('pct')) {
                              const n = Number(v);
                              if (Number.isFinite(n)) return (n * 100).toFixed(2) + '%';
                              return v;
                            }
                            // numeric formatting
                            if (!isNaN(Number(v)) && v !== '') {
                              const n = Number(v);
                              if (!Number.isInteger(n)) return n.toFixed(2);
                              return n.toLocaleString();
                            }
                            return String(v);
                          };

                          // Build groups from returned keys; prefer explicitKeyMap, then keywordGroups, otherwise 'Other'
                          const keys = Object.keys(row);
                          // Orders group placed before Expedited per request; no 'Other' group shown
                          const orderedGroupNames = ['Container', "Returns", 'Returned Items', 'Pallet', 'Parcel', 'Orders', 'Expedited', 'Urgent'];
                          const groups = {};
                          orderedGroupNames.forEach(g => { groups[g] = []; });

                          keys.forEach(k => {
                            const lowerKey = String(k).toLowerCase();
                            // drop any testing metric entirely
                            if (lowerKey === 'testing' || lowerKey === 'test') return;
                            // explicit mapping
                            if (explicitKeyMap[k]) {
                              groups[explicitKeyMap[k]] = groups[explicitKeyMap[k]] || [];
                              groups[explicitKeyMap[k]].push(k);
                              return;
                            }

                            // keyword matching
                            const lower = String(k).toLowerCase();
                            let matched = false;
                            for (const kg of keywordGroups) {
                              for (const kw of kg.keywords) {
                                if (lower.includes(kw)) {
                                  groups[kg.name] = groups[kg.name] || [];
                                  groups[kg.name].push(k);
                                  matched = true;
                                  break;
                                }
                              }
                              if (matched) break;
                            }

                            // if not matched, do not render this metric (remove 'Other' section)
                            // (This silently skips unknown/unmapped keys)
                            // if you'd prefer to see them, we can push to a visible group.
                          });

                          // Styles: tighter, smaller font
                          const cardStyle = { border: '1px solid #eee', padding: '8px', borderRadius: '4px', background: '#fff', boxShadow: 'none' };
                          const labelStyle = { fontSize: '0.78rem', color: '#666' };
                          const valueStyle = { fontSize: '1.05rem', fontWeight: 700, marginTop: '6px' };

                          return (
                            <div>
                              {Object.keys(groups).map(groupName => (
                                groups[groupName].length === 0 ? null : (
                                  <div key={groupName} style={{ marginBottom: 12 }}>
                                    <div style={{ fontSize: '0.95rem', fontWeight: 700, marginBottom: 8 }}>{groupName}</div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))', gap: '8px' }}>
                                      {groups[groupName].map(k => (
                                        <div key={k} style={cardStyle}>
                                          <div style={labelStyle}>{labelMap[k] || k.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').replace(/^./, s => s.toUpperCase())}</div>
                                          <div style={valueStyle}>{formatValue(k, row[k])}</div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )
                              ))}
                            </div>
                          );
                        })()}

                        <br />
                        
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReceivingReport;
